import { Box, Container, Skeleton } from "@mui/material";

const MyNetworkRouteSkeleton = () => (
  <Container
    maxWidth={false}
    role="status"
    aria-busy="true"
    aria-label="Loading my network"
    sx={{
      width: "100%",
      mx: "auto",
      px: { xs: "16px !important", md: "clamp(40px, 3.2vw, 64px) !important" },
      pt: "42px",
      pb: "48px",
      mb: "2rem",
      bgcolor: "#fafafa",
    }}
  >
    <Box
      sx={{
        display: "flex",
        width: "min(860px, 100%)",
        height: 52,
        p: "3px",
        mb: { xs: "10px", md: "32px" },
        borderRadius: "999px",
        bgcolor: "#fff",
        gap: "4px",
        overflow: "hidden",
      }}
    >
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          sx={{ minWidth: 116, flex: 1, height: "100%", borderRadius: "999px" }}
        />
      ))}
    </Box>
    <Box
      sx={{
        mt: "32px",
        p: { xs: "24px 16px", md: "34px 32px 32px" },
        borderRadius: "32px",
        bgcolor: "#fff",
      }}
    >
      <Skeleton variant="text" width={196} height={48} sx={{ mb: "24px" }} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(auto-fit, minmax(236px, 1fr))",
          },
          gap: "34px 20px",
        }}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <Box
            key={index}
            sx={{ height: 314, borderRadius: "14px", overflow: "hidden", bgcolor: "#fff" }}
          >
            <Skeleton variant="rounded" width="100%" height={96} />
            <Skeleton
              variant="circular"
              width={120}
              height={120}
              sx={{ mx: "auto", mt: "-64px", position: "relative" }}
            />
            <Skeleton variant="text" width="60%" height={30} sx={{ mx: "auto", mt: 1 }} />
            <Skeleton variant="text" width="45%" height={20} sx={{ mx: "auto" }} />
            <Skeleton
              variant="rounded"
              width="78%"
              height={40}
              sx={{ mx: "auto", mt: 5, borderRadius: "999px" }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  </Container>
);

export default MyNetworkRouteSkeleton;
